import { Company } from '../../../types/company/Company'

export interface CustomerQueryParams {
  companyId?: Company['id']
}

const customerQueryKeys = {
  all: [{ scope: 'customer' }] as const,
  lists: () => [{ ...customerQueryKeys.all[0], entity: 'list' }] as const,
  list: (params: CustomerQueryParams) => [{ ...customerQueryKeys.lists()[0], ...params }] as const
}

export default customerQueryKeys
